import {
  IconAskQuestionOutline,
  IconEyeOpenOutline,
  IconSparkleOutline,
  IconTrendingOutline,
} from '@zillow/constellation';

const getActiveProductTypePremiumFeatures = () => [
  {
    heading: 'More exposure',
    body: 'Renters searching in your area will see your listing more often.',
    Icon: IconEyeOpenOutline,
    modalContent:
      'Your premium listing will be given prominent placement to draw extra attention from renters, increasing the likelihood that they’ll contact you.',
  },
  {
    heading: 'Listing recommendations',
    body: 'Appeal to more renters by following our customized tips.',
    Icon: IconSparkleOutline,
    modalContent:
      'Based on the information you include in your listing, we’ll give you in-depth tips on how to add more of the details that attract quality renters.',
  },
  {
    heading: 'Pricing & market insights',
    body: 'Track your listing’s performance and trends in your market.',
    Icon: IconTrendingOutline,
    modalContent:
      'See how your listing compares to similar rentals in your area, including rent price, page views, and number of inquiries. You’ll be able to learn how competitive your market is, and whether your listing is standing out.',
  },
  {
    heading: 'Get priority support',
    body: 'Save time & effort with prioritized responses to your questions.',
    Icon: IconAskQuestionOutline,
    modalContent:
      'You’ll get access to our priority support queue, so you can resolve your questions more easily and efficiently.',
  },
];

const getActiveProductTypeFreeFeatures = () => [
  {
    heading: 'More exposure',
    body: "Renters can't miss your listing in their inbox & search results.",
    Icon: IconEyeOpenOutline,
    modalContent:
      'Your premium listing will be given prominent placement to draw extra attention from renters, increasing the likelihood that they’ll contact you.',
  },
  {
    heading: 'Listing recommendations',
    body: 'Appeal to more renters by following our customized tips.',
    Icon: IconSparkleOutline,
    modalContent:
      'Based on the information you include in your listing, we’ll give you in-depth tips on how to add more of the details that attract quality renters.',
  },
  {
    heading: 'Custom analytics',
    body: 'Track your listing’s performance and trends in your market.',
    Icon: IconTrendingOutline,
    modalContent:
      'See how your listing compares to similar rentals in your area, including rent price, page views, and number of inquiries. You’ll be able to learn how competitive your market is, and whether your listing is standing out.',
  },
  {
    heading: 'Priority support',
    body: 'Save time & effort with prioritized responses to your questions.',
    Icon: IconAskQuestionOutline,
    modalContent:
      'You’ll get access to our priority support queue, so you can resolve your questions more easily and efficiently.',
  },
];

export { getActiveProductTypePremiumFeatures, getActiveProductTypeFreeFeatures };
